import {
    UTMDataState,
} from '../types/mx/reducers';

export const utmInit: UTMDataState = {
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    utmTerm: '',
    utmContent: '',
    aUtmUrl: '',
    gclid: '',
    aHttpRefer: '',
    userAgent: '',
    typeDevice: '',
    operatingSystem: '',
    resolutionWidth: 0,
    resolutionHeight: 0,
    firstReferer: ''
};